import { useEffect } from "react";
import { scrollToTop } from "../utils/helpers";

const useScrollToTop = () => {
  useEffect(scrollToTop, []);
};

export default useScrollToTop;